import { format, parseISO } from 'date-fns'
import { Dayjs } from 'dayjs'

export const formatDate = (
  date: Dayjs | string | Date | null | undefined,
  includeTime: boolean = false
): string => {
  if (!date) return 'No date specified'

  if (
    typeof date === 'object' &&
    'format' in date &&
    typeof date.format === 'function'
  ) {
    return includeTime
      ? date.format('MM/DD/YYYY, hh:mm:ss A')
      : date.format('MM/DD/YYYY')
  }

  // Handle ISO string timestamps (signoff)
  if (typeof date === 'string') {
    try {
      const parsedDate = parseISO(date)

      if (isNaN(parsedDate.getTime())) {
        return 'Invalid date'
      }

      return includeTime
        ? format(parsedDate, 'MM/dd/yyyy, hh:mm:ss a')
        : format(parsedDate, 'MM/dd/yyyy')
    } catch (error) {
      console.error('Error parsing date string:', error, date)
      return 'Invalid date'
    }
  }

  if (date instanceof Date) {
    try {
      if (isNaN(date.getTime())) {
        return 'Invalid date'
      }

      return includeTime
        ? format(date, 'MM/dd/yyyy, hh:mm:ss a')
        : format(date, 'MM/dd/yyyy')
    } catch (error) {
      console.error('Error formatting Date object:', error, date)
      return 'Invalid date'
    }
  }

  return 'Invalid date'
}

export const formatMeasurement = (
  value: number | undefined,
  unit: string | undefined
): string => {
  if (value === undefined) return 'Not specified'
  return `${value}${unit ? ` ${unit}` : ''}`
}
